export default __webpack_public_path__ + "static/media/20200721-Oracle SQL Certificate.2a770e94.jpg";